import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { AdItem } from '@sbt-web/network/types';
import { Button, ButtonLink, Icon } from '@sbt-web/ui';
import getNavigationData, { type SearchNavigationDestinations } from '@/client/bridges/navigation-data';
import DetailBreadcrumbs from '@/client/components/SEO/Breadcrumbs/DetailBreadcrumbs';
import { mapDetailToPageInfo } from '@/tools/search';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import css from './index.module.scss';
interface Props {
  item: AdItem;
}
const trackBackClick = () => {
  getOrCreatePulse()?.queueEvent({
    type: 'Click',
    object: {
      type: 'UIElement',
      '@id': 'sdrn:subito:ad_detail:navigation-bar:element:back-button',
      name: 'Back to Listing Button',
      elementType: 'Button'
    },
    page: {
      pageType: 'ad_detail',
      '@id': 'sdrn:subito:page:ad_detail',
      '@type': 'Page'
    }
  });
};
export const NavigationRow = t0 => {
  const $ = _c(18);
  const {
    item
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      listingUrl: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [navInfo, setNavInfo] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== item.urn) {
    t2 = () => {
      getNavigationData(item.urn).then(setNavInfo);
    };
    t3 = [item.urn];
    $[1] = item.urn;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = checkNativeBackCapability();
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const canNativeBack = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      trackBackClick();
      if (canNativeBack) {
        window.history.back();
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleOnClick = t5;
  const BackButton = canNativeBack ? Button : ButtonLink;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [css.backButton];
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== item || $[8] !== navInfo.listingUrl) {
    t7 = navInfo.listingUrl ?? mapDetailToPageInfo(item).url;
    $[7] = item;
    $[8] = navInfo.listingUrl;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Icon name="ArrowLeft" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <BackButton classes={t6} href={t7} onClick={handleOnClick} design="outline" size="small" icon={t8}>Torna alla ricerca</BackButton>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== item) {
    t10 = <DetailBreadcrumbs item={item} />;
    $[13] = item;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <nav className={css.navigation}>{t9}{t10}</nav>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};

// use native back to maintain scroll position if possible
// conditions: referrer from same origin and history length > 1
export const checkNativeBackCapability = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  // Ensure history length is greater than 1 (current page is always in history)
  if (window.history.length <= 1) {
    return false;
  }
  const referrer = document.referrer;
  if (!referrer) {
    return false;
  }
  try {
    const parsedReferrer = new URL(referrer);
    return parsedReferrer.origin === window.location.origin && listingPathRegex.test(parsedReferrer.pathname);
  } catch {
    return false;
  }
};
const listingPathRegex = /\/annunci-[^/]+\/(vendita|affitto)\/[^/]+/;
export default NavigationRow;